import React, { Suspense, useEffect, useState } from "react";
import { jwtDecode } from "jwt-decode";
import Sidebar from "../../component/SideBar";
import MobileSidebar from "../../component/SideBar/mobileView";
import ProtectedRoute from "../../otherRoutes/ProtectedRoute";
import AdminRoutes from "../../routes/adminRoutes";
import EmployeeRoutes from "../../routes/employeeRoutes";
import WareHouseRoutes from "../../routes/wareHouseRoutes";
import useWindowSize from "../../hooks/useWindowSize";

const MainLayout = () => {
  const [isOpen, setIsOpen] = useState(true);
  const [userType, setUserType] = useState("user");
  const [userId, setUserId] = useState(null);
  const isMobileView = useWindowSize();

  useEffect(() => {
    const token = localStorage.getItem("token");
    if (token) {
      try {
        const decoded = jwtDecode(token);
        const role = decoded.role
          ? decoded.role.toString().trim().toLowerCase()
          : "user";
        setUserType(role);
        setUserId(decoded.id || null);
      } catch (error) {
        // console.error("Failed to decode token:", error);
        setUserType("user");
        setUserId(null);
      }
    }
  }, []);

  const renderRoutes = () => {
    if (userType === "admin") return <AdminRoutes />;
    if (userType === "manager") return <WareHouseRoutes />;
    return <EmployeeRoutes />;
  };

  return (
    <div className="flex h-screen overflow-hidden">
      {/* Sidebar */}
      {isMobileView ? (
        <MobileSidebar />
      ) : (
        <Sidebar
          isOpen={isOpen}
          setIsOpen={setIsOpen}
          userType={userType}
          userId={userId}
        />
      )}

      {/* Main Content */}
      <div className="flex flex-1 flex-col min-h-0 bg-primaryLight transition-all duration-300">
        {/* Scrollable main content */}
        <main className="flex-1">
          <ProtectedRoute>
            <Suspense fallback={<div>Loading...</div>}>
              {renderRoutes()}
            </Suspense>
          </ProtectedRoute>
        </main>
      </div>
    </div>
  );
};

export default MainLayout;
